import { IntlProvider } from './IntlProvider';
import { IntlService } from './IntlService';
export { IntlProvider, IntlService };
// Automatic installation if Vue has been added to the global scope.
var vue = 'Vue';
if (typeof window !== 'undefined' && window[vue] && window[vue].component) {
    window[vue].component('kendo-intl-provider', IntlProvider);
}



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-intl/dist/es/Intl/main.js
// module id = 849
// module chunks = 93